import React, { useState, useEffect } from "react";

import SideBar from "../common/sideBar";

import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "../common/useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import moment from "moment";
const ApprovedCampaign = (props) => {
  //Set initial state
  const [campaigns, handleCampaignList] = useState([]);
  const { isShowing, toggle } = useModel();
  const { isRejectShowing, rejectToggle } = useModel();
  const [user_email, handleUserEmail] = useState("");
  const [campaignId, handleCampaignId] = useState("");
  const [searchName, handleSearchName] = useState(undefined);
  const [searchId, handleSearchId] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Approved");
  }, []);

  //Fetching the campaign details
  const getCampaignlist = async (skip, name, id, status) => {
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.campaignList, {
        params: {
          skip,
          name,
          id,
          status: "Approved",
        },
      });
      const result = data.data.data.data;
      if (result) {
        handleCampaignList(result);
        handleSearchName(name);
        handleSearchId(id);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Seraching the campaign
  const getSearch = (e) => {
    if (e.target.value.length === 24) {
      getCampaignlist(0, undefined, e.target.value, "Approved");
    } else {
      getCampaignlist(0, e.target.value, undefined, "Approved");
    }
  };

  const openPopup = (Campaign, e) => {
    handleUserEmail(Campaign.userEmail ? Campaign.userEmail : "");
    handleCampaignId(Campaign._id ? Campaign._id : "");
    toggle();
  };

  const openRejectPopup = (Campaign, e) => {
    handleUserEmail(Campaign.userEmail ? Campaign.userEmail : "");
    handleCampaignId(Campaign._id ? Campaign._id : "");
    rejectToggle();
  };

  //Return the table for campaign
  return (
    <div>
      <ApproveModel
        isShowing={isShowing}
        hide={toggle}
        user_email={user_email}
        campaignId={campaignId}
        getCampaignlist={getCampaignlist}
      />
      <RejectModel
        isRejectShowing={isRejectShowing}
        hide={rejectToggle}
        user_email={user_email}
        campaignId={campaignId}
        getCampaignlist={getCampaignlist}
      />
      <div className="dashboardContainer">
        <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <a id="logo">
              <img className="logo-trans" src="/assets/images/new_logo.png" />
            </a>
            <span>Welcome: {adminData.email} </span>
            <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
          </div>
          <div
            className="user-profile pull-right"
            tabIndex={0}
            onClick={() => {
              localStorage.removeItem("adminInfo");
              window.location.href = "/admin/login";
            }}
          >
            <a>
              <span>
                LOGOUT
                <span className="log_img">
                  <img src="/assets/images/ic_logout.png" />
                </span>
              </span>
            </a>
          </div>
        </div>
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section id="dashboard-rightContainer" className="dashboard-manageSales">
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Campaign Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Approved Campaign List
                </span>
              </div>
              <div
                className={
                  (!searchName && campaigns.length === 0) || (!searchId && campaigns.length === 0)
                    ? "search_camp none"
                    : "search_camp"
                }
              >
                <input type="text" placeholder="search" onChange={getSearch} />
                <span>
                  <img src="/assets/images/search.png" />
                </span>
              </div>
            </div>
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Campaign Name</th>
                    <th>User Email</th>
                    <th>CampaignId</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Brand</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td>{c.name}</td>
                      <td>{c.userEmail}</td>
                      <td>{c._id}</td>
                      <td>{c.product}</td>
                      <td>{c.type}</td>
                      <td>{c.brand}</td>
                      <td>{c.totalCost}</td>
                      <td className="txt-cntr">
                        <a>
                          <span className="tooltip-reject view-tooltip">
                            <img
                              src="/assets/images/eye.png"
                              className="reject-approved-img reject-png"
                              onClick={() => {
                                props.onSubmit();
                                props.getCampaignDetails(c);
                              }}
                            />
                            <span>View</span>
                          </span>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationTable" />
              {(skip > 0 || count >= 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}
            </div>
            {campaigns.length === 0 ? <NoData /> : null}
          </section>
        </div>
      </div>
      {/* {campaigns.length ===0 && (!searchName && !searchId)?
              <NoData /> : null} */}
    </div>
  );
};

export default ApprovedCampaign;



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/approvedCampaign.js